const tabletMediaQuery = '(min-width: 768px)'

class ArticleCardListingWidget {
  private readonly widgets: NodeListOf<HTMLElement>
  private readonly mediaQuery: MediaQueryList

  constructor() {
    this.widgets = document.querySelectorAll<HTMLElement>('.article-card-listing-widget')
    if (this.widgets.length === 0) return

    this.mediaQuery = window.matchMedia(tabletMediaQuery)
    this.syncWidgets()

    if (typeof this.mediaQuery.addEventListener === 'function') {
      this.mediaQuery.addEventListener('change', this.syncWidgets)
    }
  }

  private readonly syncWidgets = (): void => {
    this.widgets.forEach((widget) => {
      this.syncWidget(widget)
    })
  }

  private syncWidget(widget: HTMLElement): void {
    const desktopCta = widget.querySelector<HTMLElement>(
      '[data-article-card-listing-cta="desktop"]'
    )
    const mobileCta = widget.querySelector<HTMLElement>('[data-article-card-listing-cta="mobile"]')

    if (desktopCta == null || mobileCta == null) return

    this.setVariantState(desktopCta, this.mediaQuery.matches)
    this.setVariantState(mobileCta, !this.mediaQuery.matches)
  }

  private setVariantState(element: HTMLElement, isActive: boolean): void {
    if (isActive) {
      element.removeAttribute('hidden')
      element.removeAttribute('inert')
      element.removeAttribute('aria-hidden')
      return
    }

    element.setAttribute('hidden', '')
    element.setAttribute('inert', '')
    element.setAttribute('aria-hidden', 'true')
  }
}

export default ArticleCardListingWidget
